import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAPeriodReports() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ requireReports, setRequireReports ] = useState(powerOfAttorney.require_period_reports || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      require_period_reports: requireReports
    }));
    
    navigate('../report-recipients');
  }, [ requireReports, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-period-reports screen-container screen">
      <ScreenHeader
        title="Requiring Period Reports"
        description="Decide whether to require your agent to provide regular reports"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Period Reports?</h3>
        <p>
          Period reports are regular statements your agent provides about their 
          activities on your behalf. These reports can include:
        </p>
        <ul className="report-features">
          <li>Summary of financial transactions</li>
          <li>Account balances and changes</li>
          <li>Investment decisions made</li>
          <li>Major purchases or sales</li>
          <li>Income received and expenses paid</li>
          <li>Gifts made on your behalf</li>
        </ul>

        <h3>Benefits of Period Reports</h3>
        <ul className="report-benefits">
          <li>Provides oversight of your agent's activities</li>
          <li>Creates a record of transactions</li>
          <li>Helps detect potential problems early</li>
          <li>Keeps family members informed</li>
          <li>Ensures accountability and transparency</li>
        </ul>

        <h3>Do You Want to Require Period Reports?</h3>
        <div className="report-authorization">
          <div className="report-option">
            <label className="report-label">
              <input
                type="radio"
                name="require-reports"
                checked={!requireReports}
                onChange={() => setRequireReports(false)}
              />
              <div className="report-content">
                <h4>No</h4>
                <p>Do not require period reports from my agent</p>
              </div>
            </label>
          </div>

          <div className="report-option">
            <label className="report-label">
              <input
                type="radio"
                name="require-reports"
                checked={requireReports}
                onChange={() => setRequireReports(true)}
              />
              <div className="report-content">
                <h4>Yes</h4>
                <p>Require my agent to provide regular reports</p>
              </div>
            </label>
          </div>
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Period reports can provide valuable oversight but may also create 
            additional work for your agent. Consider the complexity of your 
            financial affairs and your family's needs when making this decision.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
